import { twMerge } from "tailwind-merge";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface ProgramAccordionProps {
    list: { title: string | React.ReactNode; background: string; img: string; contents?: React.ReactNode }[];
    triggerClassName?: string;
    contentClassName?: string;
    defaultOpenItems?: number[];
}

export default function ProgramAccordion({
    list,
    triggerClassName,
    contentClassName,
    defaultOpenItems = [],
}: ProgramAccordionProps) {
    return (
        <Accordion
            type="multiple"
            className="flex flex-col gap-[8px]"
            defaultValue={defaultOpenItems.map(index => `program_${index}`)}
        >
            {list.map((item, i) => (
                <AccordionItem key={`program_${i}`} value={`program_${i}`}>
                    <AccordionTrigger
                        className={`relative [&_svg]:size-[24px] [&>svg]:text-white [&>svg]:stroke-1 [&>svg]:mr-[8px] hover:no-underline p-[4px] bg-program202501 md:[&_svg]:size-[60px] md:[&>svg]:mr-[20px]${!item.contents ? " cursor-default" : ""} ${!item.contents ? " [&>svg]:hidden" : ""} ${item.background} bg-cover`}
                    >
                        <div className="absolute top-[4px] left-[4px] border-2 border-white w-[calc(100%-8px)] h-[calc(100%-8px)]" />
                        <div
                            className={twMerge(
                                "w-full flex items-center justify-between px-[8px] py-[15px] xl:px-[20px]",
                                triggerClassName,
                            )}
                        >
                            <img src={item.img} alt="프로그램" className="h-[16px] md:h-[auto]" />
                            <p className="text-[16px] text-left text-white font-['GongGothicMedium'] md:text-[24px]">
                                {item.title}
                            </p>
                        </div>
                    </AccordionTrigger>
                    {item.contents && (
                        <AccordionContent
                            className={twMerge(
                                "p-[8px] text-[13px] bg-white font-['GongGothicLight'] leading-[1.5] md:text-[16px] md:p-[18px]",
                                contentClassName,
                            )}
                        >
                            {item.contents}
                        </AccordionContent>
                    )}
                </AccordionItem>
            ))}
        </Accordion>
    );
}
